import React from "react"
import { Badge } from "../../shared/components/Badge"
import { LiabilityStatusEnum } from "../../shared/utils"
import { useCMSReady } from "../../../domain/CMS/useCMSReady"
import { LiabilityInsurance } from "../../../domain/Provider/schema"
import { PublicPractice } from "../../../domain/Profile/schema"
import { getLocationLiabilityStatus } from "../utils/liabilityStatusHelpers"

interface LiabilityStatusBadgeProps {
  practice: PublicPractice
  providerLiabilityInsurances?: LiabilityInsurance[]
  className?: string
}

export const LiabilityStatusBadge: React.FC<LiabilityStatusBadgeProps> = ({
  practice,
  providerLiabilityInsurances,
}) => {
  const { cms: cmsContent } = useCMSReady(["publicProfileSlide"])
  const publicProfileText = cmsContent.publicProfileSlide

  const { status, isGroupPolicy } = getLocationLiabilityStatus(
    practice,
    providerLiabilityInsurances,
  )
  // Don't show badge for active status (per requirements)
  if (status === LiabilityStatusEnum.ACTIVE) {
    return null
  }

  const getBadgeText = () => {
    const prefix = isGroupPolicy
      ? (publicProfileText?.practiceLiabilityText ?? "")
      : (publicProfileText?.providerLiabilityText ?? "")

    switch (status) {
      case LiabilityStatusEnum.REQUIRED:
      case LiabilityStatusEnum.NOT_AVAILABLE:
        return `${prefix} ${publicProfileText?.statusRequiredText ?? ""}`
      case LiabilityStatusEnum.EXPIRED:
        return `${prefix} ${publicProfileText?.statusExpiredText ?? ""}`
      case LiabilityStatusEnum.PENDING:
        return `${prefix} ${publicProfileText?.statusPendingText ?? ""}`
      case LiabilityStatusEnum.EXPIRING_SOON:
        return `${prefix} ${publicProfileText?.statusExpiringSoonText ?? ""}`
      default:
        return null
    }
  }
  const badgeText = getBadgeText()

  if (!badgeText) {
    return null
  }

  return (
    <div className="items-center w-fit pb-4">
      <Badge
        text={badgeText}
        color={status === LiabilityStatusEnum.PENDING ? "purple" : "red"}
      />
    </div>
  )
}
